import { TopBarMobile } from "@/components/topBarMobile/topBarMobile";
import { showTranslated, translate } from "@/config/translator";
import { formatPhoneNumber } from "@/config/utils";
import { ContactPersonElement } from "./contactPersonMobile/contactPersonElement";
import { useContactPersonMobile } from "./contactPersonMobile/useContactPersonMobile";

export default function ContactPersonMobile() {
  const { lang, navigate, isTablet, noContact, selectedMandate } =
    useContactPersonMobile();

  if (isTablet) return null;

  return (
    <>
      <TopBarMobile onBack={() => navigate(-1)} header="contact" />
      {noContact ? (
        <p className="text-font-secondary p-6">
          {translate("noContactAvailable", lang)}
        </p>
      ) : selectedMandate ? (
        <>
          {selectedMandate.buchhalter && (
            <ContactPersonElement
              person={selectedMandate.buchhalter}
              lang={lang}
              type="buchhalter"
            />
          )}
          {selectedMandate.beraterBuchhaltung && (
            <ContactPersonElement
              person={selectedMandate.beraterBuchhaltung}
              lang={lang}
              type="berater_buchhaltung"
            />
          )}
          {selectedMandate.lohnBuchhalter && (
            <ContactPersonElement
              person={selectedMandate.lohnBuchhalter}
              lang={lang}
              type="lohnbuchhalter"
            />
          )}
          {selectedMandate.beraterLoehne && (
            <ContactPersonElement
              person={selectedMandate.beraterLoehne}
              lang={lang}
              type="berater_loehne"
            />
          )}
        </>
      ) : (
        <p className="text-font-secondary">
          {translate("noMandateSelected", lang)}
        </p>
      )}
      <div className="text-xs text-font-secondary w-full text-center mt-8 flex flex-col gap-2">
        {selectedMandate?.filialeBuchhaltung && (
          <div>
            <div>{translate("yourAccountingBranch", lang)}</div>
            <div>
              {`${showTranslated(
                selectedMandate.filialeBuchhaltung.name,
                lang,
              )} ⸱ ${showTranslated(selectedMandate.filialeBuchhaltung.address, lang)} ⸱ ${
                selectedMandate.filialeBuchhaltung.mail
              } ⸱ ${formatPhoneNumber({
                phoneNumber: selectedMandate.filialeBuchhaltung.phone,
                isMobile: false,
              })}`}
            </div>
          </div>
        )}
        {selectedMandate?.filialeLoehne && (
          <div>
            <div>{translate("yourPayrollBranch", lang)}</div>
            <div>
              {`${showTranslated(
                selectedMandate.filialeLoehne.name,
                lang,
              )} ⸱ ${showTranslated(selectedMandate.filialeLoehne.address, lang)} ⸱ ${
                selectedMandate.filialeLoehne.mail
              } ⸱ ${formatPhoneNumber({
                phoneNumber: selectedMandate.filialeLoehne.phone,
                isMobile: false,
              })}`}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
